import { useEffect, useState } from "react"

interface UseConditionalInputReturnType {
  value: string
  onValueChange: (value: string) => void
}

export const useConditionalInput = (
  fallbackValue: string,
  condition: boolean
): UseConditionalInputReturnType => {
  const [value, setValue] = useState("")

  useEffect(() => {
    if (condition && value.trim() === "") {
      setValue(fallbackValue) // Only set when empty and condition is true
    }
  }, [condition, fallbackValue])

  return {
    value,
    onValueChange: setValue,
  }
}
